/**
 * @generated SignedSource<<f3849d4ffee666b13c8fa05b549678f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckArticleRenderTypeArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckCanShowInPlusPlatformContent" | "helpersCheckIsPlusArticle" | "helpersCheckIsPostMagazineArticle" | "helpersCheckIsStyleArticle" | "helpersGetArticleTypeArticle">;
  readonly " $fragmentType": "helpersCheckArticleRenderTypeArticle";
};
export type helpersCheckArticleRenderTypeArticle$key = {
  readonly " $data"?: helpersCheckArticleRenderTypeArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckArticleRenderTypeArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckArticleRenderTypeArticle"
};

(node as any).hash = "b568230671343425538aa9ab7ab47f0e";

export default node;
